import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@dropbox/dig-components/buttons';
import { UIIcon } from '@dropbox/dig-icons';
import { ShowLine, HideLine } from '@dropbox/dig-icons/assets';
import { useFileViewerContext } from 'js/file_viewer/contexts/file_viewer';
import { areToolsHiddenAtom } from 'js/file_viewer/core/atoms/ui/general';
import { useFileViewerAtom } from 'js/file_viewer/core/atoms/use_atom';
import { UserAction, UserActionContext } from 'js/file_viewer/core/logging/constants';
import { useStabilizedCallback } from 'js/file_viewer/core/utils/useStabilizedCallback';
export const HideToolbarButton = () => {
    const intl = useIntl();
    const { logUserAction, optionalIOClients: { preferencesClient }, } = useFileViewerContext();
    const [areToolsHidden, setAreToolsHidden] = useFileViewerAtom(areToolsHiddenAtom);
    const icon = areToolsHidden ? ShowLine : HideLine;
    const label = areToolsHidden
        ? intl.formatMessage({ id: "qJIBhE", defaultMessage: "Show toolbar" })
        : intl.formatMessage({ id: "Pwe/D+", defaultMessage: "Hide toolbar" });
    const onClick = useStabilizedCallback(() => {
        var _a;
        if (areToolsHidden) {
            logUserAction(UserAction.ShowTools, UserActionContext.PreviewToolbar);
            setAreToolsHidden(false);
        }
        else {
            logUserAction(UserAction.HideTools, UserActionContext.PreviewToolbar);
            setAreToolsHidden(true);
        }
        (_a = preferencesClient === null || preferencesClient === void 0 ? void 0 : preferencesClient.ui) === null || _a === void 0 ? void 0 : _a.setHiddenState({ isHidden: !areToolsHidden });
    });
    return (React.createElement(Button, { variant: "opacity", withIconStart: React.createElement(UIIcon, { src: icon }), onClick: onClick }, label));
};
HideToolbarButton.displayName = "HideToolbarButton"
//# sourceMappingURL=hide_toolbar_button.preenvesnextjs.map
